"use client"

import { useState, useEffect } from "react"
import { useNavigate, useSearchParams, Link } from "react-router-dom"
import { signInWithEmailAndPassword } from "firebase/auth"
import { auth } from "./Authenticator/firebase"
import { useAuth } from "../context/AuthContext"
import "../styles/landing-styles.css"

// Íconos para la sección de características
function ChatIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      <line x1="9" y1="10" x2="15" y2="10" />
      <line x1="9" y1="14" x2="12" y2="14" />
    </svg>
  )
}

function SeedIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M12 22V12" strokeLinecap="round" />
      <path d="M12 12C12 12 8 8 8 5C8 2 12 2 12 2C12 2 16 2 16 5C16 8 12 12 12 12Z" />
      <path d="M12 8C12 8 16 6 18 8C20 10 18 14 12 12" />
      <path d="M12 8C12 8 8 6 6 8C4 10 6 14 12 12" />
    </svg>
  )
}

function ChartIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
      <line x1="3" y1="20" x2="21" y2="20" />
    </svg>
  )
}

function TeamIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  )
}

// Componente del ícono de Google
function GoogleIcon() {
  return (
    <svg className="landing-google-icon" viewBox="0 0 24 24">
      <path
        fill="#4285F4"
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
      />
      <path
        fill="#34A853"
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
      />
      <path
        fill="#FBBC05"
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
      />
      <path
        fill="#EA4335"
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
      />
    </svg>
  )
}

// Componente del ícono de ojo (mostrar/ocultar contraseña)
function EyeIcon({ visible }) {
  if (visible) {
    return (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
        <line x1="1" y1="1" x2="23" y2="23" />
      </svg>
    )
  }
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  )
}

// Header del landing
function Header() {
  return (
    <header className="landing-header">
      <div className="landing-logo">
        <img src="/logosinnombresinfondo.png" alt="Deitana" className="landing-logo-img" />
        <span className="landing-logo-text">Deitana IA</span>
      </div>
      <div className="landing-nav-actions">
        <Link to="/register" className="landing-btn-contact">Crear cuenta</Link>
      </div>
    </header>
  )
}

// Sección "Conoce a Deitana"
function ConoceDeitanaSection() {
  return (
    <section className="conoce-section">
      <div className="conoce-header">
        <h2 className="conoce-title">Conoce a Deitana</h2>
        <p className="conoce-subtitle">
          Deitana es un sistema de gestión inteligente para semilleros, potenciado con IA para ayudarte 
          a optimizar tu producción y tomar mejores decisiones.
        </p>
      </div>

      <div className="conoce-content">
        <div className="conoce-image-container">
          <img
            src="/imagenfoto3.jpg"
            alt="Deitana"
            className="conoce-image"
          />
        </div>

        <div className="conoce-features">
          <div className="feature-item feature-item-active">
            <div className="feature-icon">
              <ChatIcon />
            </div>
            <div className="feature-content">
              <h3 className="feature-title">Asistente IA integrado</h3>
              <p className="feature-description">
                Consulta información, genera reportes y obtén respuestas instantáneas sobre tu producción 
                con nuestro asistente conversacional.
              </p>
            </div>
          </div>

          <div className="feature-item">
            <div className="feature-icon">
              <SeedIcon />
            </div>
            <div className="feature-content">
              <h3 className="feature-title">Gestión de semillas</h3>
              <p className="feature-description">
                Controla el inventario, seguimiento de lotes y estado de tus semillas en tiempo real.
              </p>
            </div>
          </div>

          <div className="feature-item">
            <div className="feature-icon">
              <ChartIcon />
            </div>
            <div className="feature-content">
              <h3 className="feature-title">Análisis y reportes</h3>
              <p className="feature-description">
                Visualiza métricas clave, partidas de riesgo y genera informes detallados.
              </p>
            </div>
          </div>

          <div className="feature-item">
            <div className="feature-icon">
              <TeamIcon />
            </div>
            <div className="feature-content">
              <h3 className="feature-title">Colaboración en equipo</h3>
              <p className="feature-description">
                Trabaja junto a tu equipo con acceso compartido y permisos personalizados.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

// Card de Login
function LoginCard({ 
  email, 
  setEmail, 
  password, 
  setPassword, 
  showPassword, 
  setShowPassword, 
  error, 
  isLoading, 
  handleSubmit 
}) {
  return (
    <div className="landing-login-card">
      {/* Botón de Google (deshabilitado por ahora) */}
      <button className="landing-btn-google" type="button" disabled style={{ opacity: 0.5, cursor: 'not-allowed' }}>
        <GoogleIcon />
        Continuar con Google (próximamente)
      </button>

      <div className="landing-divider">o</div>

      <form onSubmit={handleSubmit}>
        <div className="landing-form-group">
          <label className="landing-form-label" htmlFor="email">Correo electrónico</label>
          <input
            type="email"
            id="email"
            className="landing-input"
            placeholder="tu@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={isLoading}
          />
        </div>

        <div className="landing-form-group">
          <label className="landing-form-label" htmlFor="password">Contraseña</label>
          <div className="landing-password-container">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              className="landing-input"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={isLoading}
              style={{ paddingRight: '48px' }}
            />
            <button
              type="button"
              className="landing-password-toggle"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
              disabled={isLoading}
            >
              <EyeIcon visible={showPassword} />
            </button>
          </div>
        </div>

        {error && <p className="landing-error-message">{error}</p>}

        <button
          type="submit"
          className="landing-btn-submit"
          disabled={isLoading}
        >
          {isLoading ? "Iniciando sesión..." : "Iniciar sesión"}
        </button>
      </form>

      <div className="landing-register-link">
        <p>
          ¿No tienes una cuenta?{' '}
          <Link to="/register">Crear cuenta</Link>
        </p>
      </div>

      <p className="landing-privacy-text">
        Al continuar, aceptas nuestros{" "}
        <a href="/terms" className="landing-privacy-link">Términos de servicio</a>{" "}
        y{" "}
        <a href="/privacy" className="landing-privacy-link">Política de privacidad</a>.
      </p>
    </div>
  )
}

const Login = () => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [error, setError] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const { user, loading, needsSetup } = useAuth()
  const [searchParams] = useSearchParams()

  // Asegurar que el body permita scroll y prevenir overflow horizontal
  useEffect(() => {
    const body = document.body
    const html = document.documentElement
    const root = document.getElementById('root')
    
    // Agregar clases
    body.classList.add('landing-page-active')
    html.classList.add('landing-page-active')
    if (root) root.classList.add('landing-page-active')
    
    // Forzar estilos inline para asegurar que funcione
    body.style.overflowY = 'auto'
    body.style.overflowX = 'hidden'
    body.style.height = 'auto'
    body.style.position = 'relative'
    body.style.maxHeight = 'none'
    body.style.width = '100%'
    body.style.maxWidth = '100vw'
    body.style.overscrollBehaviorX = 'none'
    
    html.style.overflowY = 'auto'
    html.style.overflowX = 'hidden'
    html.style.height = 'auto'
    html.style.position = 'relative'
    html.style.maxHeight = 'none'
    html.style.width = '100%'
    html.style.maxWidth = '100vw'
    html.style.overscrollBehaviorX = 'none'
    
    if (root) {
      root.style.overflowX = 'hidden'
      root.style.width = '100%'
      root.style.maxWidth = '100vw'
      root.style.position = 'relative'
    }
    
    return () => {
      // Remover clases
      body.classList.remove('landing-page-active')
      html.classList.remove('landing-page-active')
      if (root) root.classList.remove('landing-page-active')
      
      // Remover estilos inline
      body.style.overflowY = ''
      body.style.overflowX = ''
      body.style.height = ''
      body.style.position = ''
      body.style.maxHeight = ''
      body.style.width = ''
      body.style.maxWidth = ''
      body.style.overscrollBehaviorX = ''
      
      html.style.overflowY = ''
      html.style.overflowX = ''
      html.style.height = ''
      html.style.position = ''
      html.style.maxHeight = ''
      html.style.width = ''
      html.style.maxWidth = ''
      html.style.overscrollBehaviorX = ''
      
      if (root) {
        root.style.overflowX = ''
        root.style.width = ''
        root.style.maxWidth = ''
        root.style.position = ''
      }
    }
  }, [])

  // Si el usuario ya está autenticado, redirigir según su estado
  useEffect(() => {
    if (!loading && user && user.uid) {
      const redirectUrl = searchParams.get('redirect')
      
      if (needsSetup) {
        if (redirectUrl) {
          navigate(`/configuser?redirect=${encodeURIComponent(redirectUrl)}`, { replace: true })
        } else {
          navigate("/configuser", { replace: true })
        }
      } else {
        if (redirectUrl) {
          navigate(redirectUrl, { replace: true })
        } else {
          navigate("/home", { replace: true })
        }
      }
    }
  }, [user, loading, needsSetup, navigate, searchParams])

  // Mostrar loading mientras se verifica la autenticación
  if (loading) {
    return (
      <div className="landing-loading">
        <p>Cargando...</p>
      </div>
    )
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    setError("")

    try {
      console.log("🔐 Intentando autenticación Firebase...")
      await signInWithEmailAndPassword(auth, email, password)
      console.log("✅ Autenticación exitosa")
    } catch (err) {
      console.error("❌ Error de autenticación Firebase:", err)
      
      let errorMessage = "Error de autenticación"
      
      switch (err.code) {
        case 'auth/invalid-email':
          errorMessage = "El formato del email no es válido"
          break
        case 'auth/user-disabled':
          errorMessage = "Esta cuenta ha sido deshabilitada"
          break
        case 'auth/user-not-found':
          errorMessage = "No existe una cuenta con este email"
          break
        case 'auth/wrong-password':
          errorMessage = "Contraseña incorrecta"
          break
        case 'auth/invalid-credential':
          errorMessage = "Credenciales inválidas. Verifica tu email y contraseña"
          break
        case 'auth/too-many-requests':
          errorMessage = "Demasiados intentos fallidos. Intenta de nuevo más tarde"
          break
        case 'auth/network-request-failed':
          errorMessage = "Error de conexión. Verifica tu internet"
          break
        default:
          errorMessage = `Error: ${err.message || "Correo o contraseña incorrectos"}`
      }
      
      setError(errorMessage)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="landing-page">
      <Header />
      <main className="landing-main">
        <div className="landing-content-left">
          <h1 className="landing-headline">
            <span className="landing-headline-highlight">Gestión</span>
            <br />
            inteligente
          </h1>
          <p className="landing-subtitle">
            Sistema de gestión para semilleros con asistente IA integrado
          </p>
          <LoginCard
            email={email}
            setEmail={setEmail}
            password={password}
            setPassword={setPassword}
            showPassword={showPassword}
            setShowPassword={setShowPassword}
            error={error}
            isLoading={isLoading}
            handleSubmit={handleSubmit}
          />
        </div>
        <div className="landing-content-right">
          <video
            src="/video1.mp4"
            className="landing-hero-image"
            autoPlay
            loop
            muted
            playsInline
          />
        </div>
      </main>
      <ConoceDeitanaSection />
      <Footer />
    </div>
  )
}

// Footer Component
function Footer() {
  return (
    <footer className="landing-footer">
      <div className="landing-footer-container">
        <div className="landing-footer-logo">
          <span className="landing-footer-logo-text">Deitana IA</span>
        </div>
        
        <div className="landing-footer-columns">
          <div className="landing-footer-column">
            <h4 className="landing-footer-heading">Productos</h4>
            <ul className="landing-footer-links">
              <li><a href="#!">Deitana IA</a></li>
              <li><a href="#!">Deitana Code</a></li>
              <li><a href="#!">Iniciar sesión</a></li>
            </ul>
            
            <h4 className="landing-footer-heading">Características</h4>
            <ul className="landing-footer-links">
              <li><a href="#!">Deitana y Slack</a></li>
              <li><a href="#!">Deitana en Excel</a></li>
              <li><a href="#!">Habilidades</a></li>
            </ul>
            
            <h4 className="landing-footer-heading">Modelos</h4>
            <ul className="landing-footer-links">
              <li><a href="#!">Opus</a></li>
              <li><a href="#!">Sonnet</a></li>
              <li><a href="#!">Haiku</a></li>
            </ul>
          </div>
          
          <div className="landing-footer-column">
            <h4 className="landing-footer-heading">Deitana Developer Platform</h4>
            <ul className="landing-footer-links">
              <li><a href="#!">Resumen</a></li>
              <li><a href="#!">Documentación para desarrolladores</a></li>
            </ul>
          </div>
          
          <div className="landing-footer-column">
            <h4 className="landing-footer-heading">Aprender</h4>
            <ul className="landing-footer-links">
              <li><a href="#!">Blog</a></li>
              <li><a href="#!">Red de socios de Deitana</a></li>
              <li><a href="#!">Catálogo</a></li>
              <li><a href="#!">Cursos</a></li>
              <li><a href="#!">Casos de uso</a></li>
              <li><a href="#!">Conectores</a></li>
              <li><a href="#!">Ingeniería en Deitana</a></li>
              <li><a href="#!">Eventos</a></li>
              <li><a href="#!">Desarrollado por Deitana</a></li>
            </ul>
            
            <h4 className="landing-footer-heading">Empresa</h4>
            <ul className="landing-footer-links">
              <li><a href="#!">Deitana</a></li>
            </ul>
          </div>
          
          <div className="landing-footer-column">
            <h4 className="landing-footer-heading">Ayuda y seguridad</h4>
            <ul className="landing-footer-links">
              <li><a href="#!">Disponibilidad</a></li>
              <li><a href="#!">Estado</a></li>
              <li><a href="#!">Centro de soporte</a></li>
            </ul>
            
            <h4 className="landing-footer-heading">Términos y políticas</h4>
            <ul className="landing-footer-links">
              <li><a href="#!">Opciones de privacidad</a></li>
              <li><a href="#!">Política de privacidad</a></li>
              <li><a href="#!">Política de divulgación responsable</a></li>
              <li><a href="#!">Términos de servicio: Comercial</a></li>
              <li><a href="#!">Términos de servicio: Consumidor</a></li>
              <li><a href="#!">Política de uso</a></li>
            </ul>
          </div>
        </div>
      </div>
      
      <div className="landing-footer-bottom">
        <span className="landing-footer-by">BY DEITANA</span>
        <span className="landing-footer-copyright">© {new Date().getFullYear()} DEITANA PBC</span>
      </div>
    </footer>
  )
}

export default Login
